<!-- Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved. -->
<template>
  <v-img src="../assets/backgroundHome.png" class="backgroundHome">
    <v-container style="margin: 0; padding: 0" fluid>
      <v-row align="center" justify="center" style="height: 100vh; width: 100vw" dense>
        <v-col cols="12" sm="5" xl="6" lg="6" md="6" class="d-flex d-xl-flex d-sm-flex d-lg-flex d-md-flex flex-column justify-center align-center">
          <v-img :src="themeLogo" style="width: 45%; height: auto"></v-img>
        </v-col>
        <v-col
          cols="12"
          sm="7"
          xl="6"
          lg="6"
          md="6"
          style="background-color: rgba(255, 255, 255, 0.6)"
          class="fill-height d-xl-flex d-sm-flex d-lg-flex d-md-flex flex-column justify-center align-right"
        >
          <v-row>
            <v-col cols="12" class="d-xl-flex d-sm-flex d-lg-flex d-md-flex flex-column justify-center align-center">
              <flightpath-sign-in :baseUrl="appConfigBaseUrl" v-if="formState === 'signIn'"></flightpath-sign-in>
              <v-dialog v-model="dialog" persistent max-width="430px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="d-flex" text color="gray" v-bind="attrs" v-on="on">
                    <v-icon left>mdi-chevron-right</v-icon>{{ $t('auth.forgot_password') }}</v-btn
                  >
                </template>
                <v-card>
                  <flightpath-new-password v-bind:dialog.sync="dialog"></flightpath-new-password>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
import { FlightpathSignIn, FlightpathNewPassword } from '@/flightpath-components/entry';
import { FlightPathAxios } from '@/services/api';
import { getThemeName } from '@/themes';

const themeName = getThemeName();

export default {
  name: 'Auth',
  data() {
    return {
      formState: 'signIn',
      dialog: false,
      appConfigBaseUrl: new FlightPathAxios().flightPathIp,
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      themeLogo: require(`@/themes/assets/${themeName}/logo.svg`)
    };
  },
  methods: {
    bgHeight() {
      return this.$vuetify.breakpoint.height - 40;
    }
  },
  components: {
    FlightpathSignIn,
    FlightpathNewPassword
  }
};
</script>

<style scoped lang="scss">
.backgroundHome {
  width: 100vw;
  height: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
  top: 40;
}
</style>
